import gql from 'graphql-tag';
import Client from "../services/client";

const CommonAction = {

    /**
     * @purpose: fetch country list
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    listCountry(status='active') {
        const LIST_COUNTRY = gql`
                query listCountry($token: AccessToken!, $input: CountryListInput!){
                  listCountry(token: $token, input: $input){
                    code
                    status
                    message
                    data{
                      totalCount
                      countries{
                        countryId
                        name
                        dialCode
                        code
                        currencyId
                        otherJson
                        status
                        createdBy
                        updatedBy
                        createdAt
                        updatedAt
                      }
                    }
                  }
                }
            `;
        return Client.query({
            query: LIST_COUNTRY,
            variables: {
                input: {
                    status: status,
                },
                token: {
                    accessToken : 'asd',
                    accessRole : 6
                }
            }
        });
    },

    
}

export default CommonAction;
